import React, { useMemo } from 'react';
import styled from 'styled-components';
import Countdown from 'components/countdown/Countdown';
import Tag from 'components/generic/tag';
import { Typography } from 'components/generic/typography';
import { em } from 'modules/helpers/style';
import { breakpoint } from 'variables';
import { handleColor } from './shared/helpers';
import type { ISplash } from './shared/types';

const Text = styled(Typography.Label)`
    ${breakpoint.up('375px')} {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
`;

const StyledCountdown = styled(Countdown)`
    display: block;
    font-weight: inherit;
    text-transform: none;
    align-items: flex-start;
    width: unset;
`;

const SeparatorBullet = styled.span`
    display: inline-block;
    margin-left: ${em(6)};
    margin-right: ${em(6)};
    width: ${em(4)};
    height: ${em(4)};
    border-radius: 100%;
    background-color: currentColor;
    vertical-align: middle;
    margin-top: ${em(-2)};
`;

function notLast(index: number, array: any[]) {
    return index < array.length - 1;
}

export default function TagSplash(splash: ISplash): JSX.Element {
    const { lines, backgroundColor, textColor, endDate, discountId, ...restProps } = splash;
    const formattedBackgroundColor = useMemo(() => handleColor(backgroundColor), [backgroundColor]);
    const formattedTextColor = useMemo(() => handleColor(textColor), [textColor]);

    return (
        <Tag
            variant={{
                backgroundColor: formattedBackgroundColor,
                textColor: formattedTextColor
            }}
            {...restProps}
            data-discountid={discountId} // For BE debugging
        >
            <Text size="S">
                {lines.map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        {notLast(index, lines) && <SeparatorBullet />}
                    </React.Fragment>
                ))}
            </Text>

            {endDate && (
                <StyledCountdown countdown={{ finishDateTime: endDate, sizeType: 'XS', showTimeUnits: true }} />
            )}
        </Tag>
    );
}
